// v2 realtime layer config — kept isolated from the v1 queue code.
//
// We derive the v2 base from the existing v1 baseURL so that switching
// environments (localhost / test / prod) in src/lib/utils/constants.ts
// automatically moves the v2 layer with it.
import { baseURL } from "../lib/utils/constants";

// e.g. "http://localhost:8000/api/v1" -> "http://localhost:8000/api/v2"
export const baseURLV2 = baseURL.replace(/\/api\/v1\b/, "/api/v2");

// Statuses the TV cares about for the live queue.
// 0 Booked, 1 Inclinic, 2 Ongoing, 3 Completed, 4 Cancelled, 5 Timeout,
// 6 History, 7 History_Ongoing, 8 Scan, 9 Scan_Ongoing.
//
// We surface the three live queues — Inclinic, Scan, History — and tag each
// patient with which one they're currently in.
export const VISIBLE_STATUS_IDS = [1, 2, 6, 7, 8, 9];

// "Ongoing"/being-seen statuses across the three queues.
export const ONGOING_STATUS_IDS = [2, 7, 9];

export type QueueCategory = "Inclinic" | "Scan" | "History";

export const queueCategoryOf = (status?: number): QueueCategory => {
  if (status === 8 || status === 9) return "Scan";
  if (status === 6 || status === 7) return "History";
  return "Inclinic"; // 1, 2 (and fallback)
};

export const isOngoingStatus = (status?: number): boolean =>
  status != null && ONGOING_STATUS_IDS.includes(status);

// Full status-code -> display name (matches the backend status table).
export const STATUS_NAMES: Record<number, string> = {
  0: "Booked",
  1: "Inclinic",
  2: "Ongoing",
  3: "Completed",
  4: "Cancelled",
  5: "Timeout",
  6: "History",
  7: "History_Ongoing",
  8: "Scan",
  9: "Scan_Ongoing",
};

export const statusName = (status?: number): string =>
  status == null ? "" : STATUS_NAMES[status] ?? `Status ${status}`;

// EventSource auto-reconnect cadence the backend advertises (informational).
export const SSE_RETRY_MS = 3000;
